import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Client } from 'src/app/client/client';
import { ClientService } from 'src/app/client/client.service';
import { ServiceDashboardService } from '../service-dashboard.service';

@Component({
    selector: 'employee-dashboard',
    templateUrl: './employee-dashboard.component.html',
    styleUrls: ['./employee-dashboard.component.scss'],
    standalone: false
})
export class EmployeeDashboardComponent {
  allClients: Client[] = [];
  seoClients: Client[] = [];
  smmClients: Client[] = [];

  constructor(public clientService: ClientService, public dashboardService: ServiceDashboardService, public router: Router) {
  }

  ngOnInit() {
    this.allClients = this.clientService.allClients.filter(x => !x.isMatrixTools)
      .sort((a, b) => new Date(b.softwareServiceRenewalDate).getTime() - new Date(a.softwareServiceRenewalDate).getTime())
      .reverse();

    this.seoClients = this.clientService.allClients.filter(x => x.isSeoEnabled && !x.isMatrixTools)
      .sort((a, b) => new Date(b.websites[0].commitHistory[0].commit.author.date).getTime() - new Date(a.websites[0].commitHistory[0].commit.author.date).getTime())
      .reverse();
    
    debugger;//jebjebjebjeb
    let test = this.seoClients[0].websites[0].seoChartData;

    this.smmClients = this.clientService.allClients.filter(x => x.isSmmEnabled && !x.isMatrixTools)
      .sort((a, b) => new Date(b.softwareServiceRenewalDate).getTime() - new Date(a.softwareServiceRenewalDate).getTime())
      .reverse();
  }

  //jebjebjebjebjebjebj
  GoToClientDashboard(clientId: number) {
    this.mimic(clientId);
    //jeb scroll to top
  }

  GoToClientSeoDashboard(clientId: number) {
    this.mimic(clientId);
    this.router.navigate(['seo']);
    // this.router to seo?
    //jeb scroll to top
  }

  GoToClientSmmDashboard(clientId: number) {
    this.mimic(clientId);
    this.router.navigate(['smm']);
    // this.router to seo?
    //jeb scroll to top
  }

  mimic(clientId: number) {
    this.dashboardService.client = this.clientService.allClients.find(client => {
      return client.id === clientId;
    });

    this.dashboardService.website = this.dashboardService.client.websites[0];
  }
}
